import { createContext } from 'react';
var LayoutGroupContext = createContext({});
export { LayoutGroupContext };